function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "circle-minus-primary",
  d: "M12 0c3.333 0 6.167 1.166 8.5 3.5S24 8.667 24 12c0 3.3-1.167 6.134-3.5 8.5-2.333 2.333-5.167 3.5-8.5 3.5-3.3 0-6.134-1.167-8.5-3.5C1.167 18.134 0 15.3 0 12c0-3.333 1.167-6.167 3.5-8.5C5.866 1.166 8.7 0 12 0zm7 13c.267 0 .5-.1.7-.3.2-.2.3-.434.3-.7s-.1-.5-.3-.7c-.2-.2-.433-.3-.7-.3H5c-.267 0-.5.1-.7.3-.2.2-.3.433-.3.7s.1.5.3.7c.2.2.433.3.7.3h14z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "circle-minus-secondary",
  d: "M19 13H5c-.267 0-.5-.1-.7-.3-.2-.2-.3-.433-.3-.7s.1-.5.3-.7c.2-.2.433-.3.7-.3h14c.267 0 .5.1.7.3.2.2.3.434.3.7s-.1.5-.3.7c-.2.2-.433.3-.7.3z"
});

var SvgIconCircleMinus = function SvgIconCircleMinus(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconCircleMinus;